var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2 24C43.2 29.0922 41.1772 33.9758 37.5765 37.5765C33.9758 41.1772 29.0922 43.2 24 43.2C18.9079 43.2 14.0243 41.1772 10.4236 37.5765C6.8229 33.9758 4.80005 29.0922 4.80005 24C4.80005 18.9079 6.8229 14.0243 10.4236 10.4236C14.0243 6.8229 18.9079 4.80005 24 4.80005C29.0922 4.80005 33.9758 6.8229 37.5765 10.4236C41.1772 14.0243 43.2 18.9079 43.2 24ZM28.8 16.8C28.8 18.0731 28.2943 19.294 27.3942 20.1942C26.494 21.0943 25.2731 21.6 24 21.6C22.727 21.6 21.5061 21.0943 20.6059 20.1942C19.7058 19.294 19.2 18.0731 19.2 16.8C19.2 15.527 19.7058 14.3061 20.6059 13.4059C21.5061 12.5058 22.727 12 24 12C25.2731 12 26.494 12.5058 27.3942 13.4059C28.2943 14.3061 28.8 15.527 28.8 16.8ZM24 26.4C21.7023 26.3996 19.4527 27.0588 17.5186 28.2994C15.5846 29.54 14.0474 31.3098 13.0896 33.3984C14.4401 34.9695 16.1143 36.2299 17.9975 37.0932C19.8807 37.9565 21.9284 38.4023 24 38.4C26.0717 38.4023 28.1194 37.9565 30.0026 37.0932C31.8858 36.2299 33.56 34.9695 34.9104 33.3984C33.9527 31.3098 32.4155 29.54 30.4814 28.2994C28.5474 27.0588 26.2978 26.3996 24 26.4Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.396ac671.svg";
export { ForwardRef as ReactComponent };